import { Navbar } from '@/components/layout/Navbar';
import { Card, CardContent } from '@/components/ui/card';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { HelpCircle } from 'lucide-react';

const FAQ = () => {
  const faqs = [
    {
      question: 'AI生成的行程准确吗?',
      answer: 'AI会基于大量旅游数据生成行程建议,但实际旅行中可能因天气、交通、景区政策等因素产生变化。建议您将AI行程作为参考,出行前再次核实具体信息。我们也在持续优化算法,提高推荐准确性。',
    },
    {
      question: '如何修改已生成的行程?',
      answer: '在行程详情页,您可以通过对话框输入修改需求,例如"增加第二天的美食推荐"、"调整预算"等。AI会根据您的要求重新生成优化后的行程。您也可以直接编辑行程文本。',
    },
    {
      question: '支持哪些旅游目的地?',
      answer: '目前支持中国主要旅游城市及全球热门旅游目的地。如果您输入的目的地暂不支持,系统会提示您选择其他目的地,或者生成基础的旅行建议供您参考。',
    },
    {
      question: '打卡照片存储在哪里?是否安全?',
      answer: '您上传的照片存储在Supabase安全云存储中,采用加密传输和存储。我们承诺不会将您的照片用于其他用途,您可以随时删除照片及相关数据。',
    },
    {
      question: '旅行日记可以导出吗?',
      answer: '目前支持将行程导出为图片格式。我们计划在未来版本中支持日记导出为PDF或Word文档,敬请期待。',
    },
    {
      question: '免费用户有什么限制?',
      answer: '免费用户可以正常使用所有核心功能,包括行程规划、旅行日记、打卡相册等。部分高级功能(如无限次AI对话、高级模板等)可能需要付费解锁。',
    },
    {
      question: '如何删除账号及数据?',
      answer: '进入"个人中心"-"设置"-"账号管理",点击"删除账号"按钮。删除后,您的所有数据将在30天内从系统中完全清除且无法恢复,请谨慎操作。',
    },
    {
      question: '行程分享给朋友后,他们能看到我的所有数据吗?',
      answer: '不会。分享行程时,系统仅分享该条行程的详细信息,不会暴露您的个人资料、其他行程或私密日记。您可以放心分享。',
    },
    {
      question: 'AI行程规划需要多久?',
      answer: '通常在5-15秒内完成生成。复杂行程(如多城市、长天数)可能需要稍长时间。如果生成失败,请检查网络连接或稍后重试。',
    },
    {
      question: '可以同时规划多个行程吗?',
      answer: '可以。您可以在"个人中心"管理多个行程,每个行程独立保存,互不影响。',
    },
  ];

  return (
    <div className="min-h-screen bg-[#FFFFFF]">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 md:px-6 pt-28 pb-20">
        <div className="text-center mb-12">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-[#F5F5F7] mb-4">
            <HelpCircle className="w-8 h-8 text-[#007AFF]" />
          </div>
          <h1 className="text-4xl font-bold text-[#1D1D1F] mb-4 tracking-tight">常见问题</h1>
          <p className="text-lg text-[#86868B] max-w-2xl mx-auto">
            为您解答使用过程中的常见疑问
          </p>
        </div>

        <Card className="border-0 shadow-[0_4px_20px_rgba(0,0,0,0.04)] rounded-[20px] bg-[#FFFFFF]">
          <CardContent className="p-6">
            <Accordion type="single" collapsible className="w-full">
              {faqs.map((faq, idx) => (
                <AccordionItem key={idx} value={`item-${idx}`}>
                  <AccordionTrigger className="text-left text-[#1D1D1F] hover:text-[#007AFF]">
                    {faq.question}
                  </AccordionTrigger>
                  <AccordionContent className="text-[#86868B] leading-relaxed">
                    {faq.answer}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </CardContent>
        </Card>

        <Card className="border-0 shadow-[0_4px_20px_rgba(0,0,0,0.04)] rounded-[20px] bg-[#F5F5F7] mt-8">
          <CardContent className="p-8 text-center">
            <h3 className="text-lg font-bold text-[#1D1D1F] mb-2">没有找到答案?</h3>
            <p className="text-[#86868B] mb-4">
              您可以通过以下方式联系我们
            </p>
            <div className="flex justify-center gap-4 text-sm">
              <a href="#/contact" className="text-[#007AFF] hover:underline">联系客服</a>
              <span className="text-[#E8E8ED]">|</span>
              <a href="mailto:support@cattravellog.com" className="text-[#007AFF] hover:underline">发送邮件</a>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default FAQ;
